var map = {
	"./mobile/home/index.vue": [
		"c925",
		"chunk-6cd0520f",
		"chunk-46c60c20"
	],
	"./pc/home/index.vue": [
		"34ea",
		"chunk-6cd0520f",
		"chunk-4a56c208"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6234";
module.exports = webpackAsyncContext;